// extracted by mini-css-extract-plugin
export default {"option":"Book_option__wGDyW","avatar":"Book_avatar__2Ig5Q","book":"Book_book__nFUPF","title":"Book_title__32oK1","bookInfo":"Book_bookInfo__2ldHY","buttons":"Book_buttons__n2QF8"};